////////////////////////////////////////////////////////////////////////////////
// Viewport Sizes
////////////////////////////////////////////////////////////////////////////////

/**
 * Adds getters to the window and document with methods for querying their
 * respective screen dimensions
 *
 * @author Mark Notton <mark@marknotton.uk>
 *
 * @license Copyright 2019 Mark Notton
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Add width and height getter methods to the window object

if ( typeof window.width == 'undefined' ) {
  Object.defineProperty(window, 'width', {
    get : () => { return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth }
  });
}

if ( typeof window.height == 'undefined' ) {
  Object.defineProperty(window, 'height', {
    get : () => { return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight }
  });
}

// Add width and height getter methods to the document object

if ( typeof document.width == 'undefined' ) {
  Object.defineProperty(document, 'width', {
    get : (body = document.body, html = document.documentElement) => {
      return Math.max( body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth );
    }
  });
}

if ( typeof document.height == 'undefined' ) {
  Object.defineProperty(document, 'height', {
    get : (body = document.body, html = document.documentElement) => {
      return Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
    }
  });
}
